// extracted by mini-css-extract-plugin
export default {"title":"styles_title__PFUXv","content":"styles_content__MvODP"};